export const RoleEnum = {
  A: "ADMIN",
  BA: "ADMIN BIBI",
  B: "BIBI",
  FA: "ADMIN FORNECEDOR",
  F: "FORNECEDOR"
}